module.exports = __webpack_public_path__ + "static/media/33-9.3ef0b83b.mp3";